import { AerDropdownMenu } from "@aerstudios/aerated-aerdropdown";
import type { RadioGroupItem } from "@aerstudios/aerated-aerdropdown/AerDropdownMenu";
import type { WidgetProps } from "@rjsf/utils";
import type { JSONSchema7 } from "json-schema";
import React from "react";
import * as styles from "./SingleSelect.module.scss";

import { AerInputStructure } from "@aerstudios/aerated-aerinputstructure";
import { ChevronDownIcon } from "@radix-ui/react-icons";

export type SingleSelectProps = WidgetProps<{
	type: "single";
	value?: string | undefined;
	items: RadioGroupItem[];
	label: string;
	onChange: (value: string) => void;
	placeholder?: string;
	nonSchemaOptions?: string[];
}>;

export const SingleSelect: React.FC<SingleSelectProps> = ({
	schema,
	value = undefined,
	nonSchemaOptions,
	rawErrors: _rawErrors,
	...aerSelectProps
}) => {
	const { anyOf, allOf, oneOf } = aerSelectProps.schema || {};
	const { enumOptions } = aerSelectProps.options;

	const enums = enumOptions?.map((option) => ({ title: option.label }));

	const schemaItems = (anyOf || allOf || oneOf || enums) as JSONSchema7[];

	const items =
		(nonSchemaOptions?.length > 0
			? nonSchemaOptions.map((option: string) => ({
					content: option,
					value: option,
				}))
			: schemaItems.map((answer) => {
					return {
						content: answer.title as string,
						title: answer.title as string,
						value: answer.title as string,
					};
				}));

	return (
		<AerInputStructure.Root errorMessage={_rawErrors?.[0]}>
			<AerDropdownMenu.Root
				className={styles.dropdown}
				onChange={(e) => console.log(e)}
				align="start"
				alignOffset={0}
				sideOffset={0}
				trigger={
					<button
						type="button"
						aria-label={`Select a ${schema.title}`}
						className={styles.selectButton}
					>
						<span>{value || "Select a value"}</span>
						<span aria-hidden="true">
							<ChevronDownIcon />
						</span>
					</button>
				}
			>
				{items.filter((item: {title: string}) => item.title).map((item: { title: string }) => (
					<AerDropdownMenu.MenuItem
						key={item.title}
						defaultValue={value || ""}
						onSelect={() => aerSelectProps.onChange(item.title)}
						className={styles.menuItem}
					>
						{item.title}
					</AerDropdownMenu.MenuItem>
				))}
			</AerDropdownMenu.Root>
			<AerInputStructure.ErrorMessage />
		</AerInputStructure.Root>
	);
};
